"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationStatusCell = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
require("./ReservationStatusCell.scss");
const className = 'reservation-status-cell';
const ReservationStatusCell = (props) => {
    const { value } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        value === 'created' && (react_1.default.createElement("span", { className: className },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List/Status:Created', defaultMessage: 'Pending' }))),
        value === 'reserved' && (react_1.default.createElement("span", { className: `${className}--reserved` },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List/Status:Reserved', defaultMessage: 'Reserved' }))),
        value === 'confirmed' && (react_1.default.createElement("span", { className: `${className}--confirmed` },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List/Status:Confirmed', defaultMessage: 'Confirmed' }))),
        value === 'cancelled' && (react_1.default.createElement("span", { className: `${className}--cancelled` },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List/Status:Cancelled', defaultMessage: 'Cancelled' })))));
};
exports.ReservationStatusCell = ReservationStatusCell;
//# sourceMappingURL=ReservationStatusCell.js.map